// @flow
import React from 'react'
import styled from 'styled-components'
import colors from '../../../../styles/colors'
import Tr from '../../../../components/Tr'
import Td from '../../../../components/Td'

const Badge = styled.span`
  color: #fff;
  padding: 3px 8px;
  border-radius: 3px;
  font-size: 85%;
`

type Props = {
  label: string,
  status: string
}

const OfferRow = ({ label, status }: Props) => {
  let color
  switch (status) {
    case 'Pending':
      color = colors.warning
      break
    case 'Review':
      color = colors.danger
      break
    case 'Completed':
      color = colors.success
      break
    default:
      color = colors.primary
  }

  return (
    <Tr>
      <Td>{label}</Td>
      <Td style={{ textAlign: 'right' }}>
        <Badge style={{ background: color }}>{status}</Badge>
      </Td>
    </Tr>
  )
}

export default OfferRow



// WEBPACK FOOTER //
// ./src/views/UserOffers/components/OfferRow/index.js